import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserProfileRoutingModule } from './user-profile.routing';
import { CreateUserProfileComponent } from './create-user-profile/create-user-profile.component';
import { UpdateUserProfileComponent } from './update-user-profile/update-user-profile.component';
import { ListUserProfileComponent } from './list-user-profile/list-user-profile.component';
import { ShowUserProfileComponent } from './show-user-profile/show-user-profile.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { UserProfileFormComponent } from './user-profile-form/user-profile-form.component';

@NgModule({
  declarations: [
    ListUserProfileComponent,
    CreateUserProfileComponent,
    UpdateUserProfileComponent,
    ShowUserProfileComponent,
    UserProfileFormComponent
  ],
  imports: [SharedModule, UserProfileRoutingModule]
})
export class UserProfileModule {}
